import React, { useState } from "react";

// Helper function to import all images in a folder dynamically
const importAll = (r) => r.keys().map(r);

// Dynamic imports per campus using regex
const adawImages = importAll(
  require.context(
    "../../../assets/images/profle/campus", 
    false, 
    /^\.\/0\d+\.jpg$/  // Matches 01.jpg, 02.jpg, etc.
  )
);

const shahidImages = importAll(
  require.context(
    "../../../assets/images/profle/campus", 
    false, 
    /^\.\/B\d+\.jpg$/i  // Matches B1.jpg, B2.jpg, case-insensitive
  )
);

const shurieImages = importAll(
  require.context(
    "../../../assets/images/profle/campus", 
    false, 
    /^\.\/C\d/  // Matches C1.jpg, A2.jpg, etc.
  )
);

const campuses = [
  {
    name: "Dr. Adaw Campus",
    address: "Km4, Hodan District, Mogadishu",
    images: adawImages,
  },
  {
    name: "Dr. Shahid Campus",
    address: "Km13, Mogadishu",
    images: shahidImages,
  },
  {
    name: "Prof. Shurie Campus",
    address: "Ex-Control Balcad, Heliwa, Mogadishu",
    images: shurieImages,
  },
];

const CampusCard = ({ campus }) => {
  const [index, setIndex] = useState(0);

  const next = () => setIndex((prev) => (prev + 1) % campus.images.length);
  const prev = () =>
    setIndex((prev) => (prev === 0 ? campus.images.length - 1 : prev - 1));

  return (
    <div className="bg-white/70 backdrop-blur-md p-6 rounded-3xl shadow-xl border border-gray-200 flex flex-col items-center w-full space-y-5">
      {/* Campus name & address */}
      <div className="text-center">
        <p className="text-3xl sm:text-xl font-bold text-gray-900">{campus.name}</p>
        <p className="text-gray-600 mt-1">{campus.address}</p>
      </div>

      {/* Slideshow */}
      <div className="relative w-full max-w-2xl overflow-hidden rounded-2xl">
        <img
          key={index}
          src={campus.images[index]}
          alt={`${campus.name} ${index + 1}`}
          className="w-full h-auto rounded-2xl shadow-lg transition-opacity duration-500 ease-in-out opacity-100"
          loading="lazy"
        />

        {/* Prev/Next buttons */}
        {campus.images.length > 1 && (
          <>
            <button
              onClick={prev}
              aria-label="Previous image"
              className="absolute top-1/2 left-3 -translate-y-1/2 bg-white/70 backdrop-blur-md hover:bg-white text-gray-700 px-3 py-2 rounded-full shadow-md"
            >
              ❮
            </button>
            <button
              onClick={next}
              aria-label="Next image"
              className="absolute top-1/2 right-3 -translate-y-1/2 bg-white/70 backdrop-blur-md hover:bg-white text-gray-700 px-3 py-2 rounded-full shadow-md"
            >
              ❯
            </button>
          </>
        )}

        {/* Indicators */}
        <div className="absolute bottom-3 w-full flex justify-center gap-2">
          {campus.images.map((_, i) => (
            <span
              key={i}
              onClick={() => setIndex(i)}
              className={`h-3 w-3 rounded-full cursor-pointer transition-all ${
                i === index ? "bg-blue-600 scale-125" : "bg-gray-300"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const Campus = () => {
  return (
    <div className="px-4 py-16 bg-gradient-to-b from-blue-50 to-white min-h-screen flex flex-col items-center">

      {/* Title */}
      <p className="uppercase text-5xl sm:text-3xl text-gray-900 font-bold font-montserrat mb-6 tracking-wide">
        Our Campus
      </p>

      {/* Introduction */}
      <p className="max-w-3xl text-center text-gray-700 text-lg sm:text-base mb-12 leading-relaxed">
        Since 2002, Benadir University has developed into a multi-campus environment
        committed to academic excellence and practical learning. Each campus is equipped
        with specialized laboratories for every faculty, including Dentistry, Information
        Technology, Agriculture, and Health Sciences. Our facilities also include a teaching
        hospital, a comprehensive library, an English Language Center, an Innovation Hub
        for research and creativity, and more.
      </p>

      {/* Campus cards */}
      <div className="w-full max-w-4xl space-y-20">
        {campuses.map((campus, i) => (
          <CampusCard campus={campus} key={i} />
        ))}
      </div>
    </div>
  );
};

export default Campus;
